import { useQuery, useMutation, useQueryClient } from "@tanstack/react-query";
import { supabase } from "@/integrations/supabase/client";
import { toast } from "sonner";

export const useSystemSettings = () => {
  return useQuery({
    queryKey: ['system-settings'],
    queryFn: async () => {
      const { data, error } = await supabase
        .from('site_settings')
        .select('*');
      
      if (error) throw error;
      
      // Convert array to object for easier access
      const settings: Record<string, string> = {};
      data?.forEach((setting: any) => {
        settings[setting.key] = setting.value;
      });
      
      return settings;
    },
    staleTime: 1000 * 60 * 5, // 5 minutes
  });
};

export const useUpdateSystemSetting = () => {
  const queryClient = useQueryClient();
  
  return useMutation({
    mutationFn: async ({ key, value }: { key: string; value: string }) => {
      const { data: { user } } = await supabase.auth.getUser();
      if (!user) throw new Error("Not authenticated");

      const { data: profile } = await supabase
        .from('profiles')
        .select('role')
        .eq('id', user.id)
        .single();
      if ((profile as any)?.role !== 'admin' && (profile as any)?.role !== 'super_admin') {
        throw new Error("Admin access required");
      }

      const { error } = await supabase
        .from('site_settings' as any)
        .upsert({ key, value } as any);
      
      if (error) throw error;
      return { key, value };
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['system-settings'] });
    },
    onError: (error) => {
      console.error(error);
      toast.error("שגיאה בשמירת ההגדרות");
    }
  });
};

export const getMediaType = (url: string): 'video' | 'image' | 'unknown' => {
  if (!url) return 'unknown';
  const cleanUrl = url.split('?')[0].toLowerCase();
  if (cleanUrl.match(/\.(mp4|webm|mov|m4v)$/)) return 'video';
  if (cleanUrl.match(/\.(jpg|jpeg|png|webp|avif|gif|svg)$/)) return 'image';
  return 'image'; // Default to image if unknown, as many CDNs don't have extensions
};